import { MapStoreMunicipality } from '../../../shared/models/municipality/Municipality';
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfigurationService } from '@app/shared/services/api/configuration.service';
import { AuthService } from '@app/shared/services/auth.service';
import { distinctUntilChanged, filter as rxfilter, switchMap, takeUntil } from 'rxjs/operators';
import { OverlayLoaderService } from '../../../shared/services/overlay-loader.service';
import { isNil, filter } from 'lodash';
import { isJsonString } from '../../../shared/utility';
import { environment } from '@env/environment';
import { AppInsightsServiceDirective } from '@app/shared/services/app-insights.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';

@Component({
  selector: 'app-innolive-teaser',
  templateUrl: './innolive-teaser.component.html',
  styleUrls: ['./innolive-teaser.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InnoliveTeaserComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<void> = new Subject();
  configuration: string[] = [];
  baseURL = `${environment.tenant}/teasers/innolive`;
  subs: Subscription = new Subscription();
  router: any;

  constructor(
    private configurationService: ConfigurationService,
    public authService: AuthService,
    private loading: OverlayLoaderService,
    public appInsightsServiceDirective: AppInsightsServiceDirective,
    private _router: Router,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {}

  ngOnInit() {
    this.loading.isGlobalLoader = false;
    this.loading.isLoading = true;

    this.userMunicipalitiesService.currentMunicipality$
      .pipe(
        rxfilter((municipality: MapStoreMunicipality) => !!municipality?.guid && !!municipality?.key),
        distinctUntilChanged(),
        switchMap(() => this.authService.permissionLoadComplete$.asObservable()),
        rxfilter((isLoaded: boolean) => isLoaded),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => {
        const p = this.authService.permissions['INNO_LIVE'];
        if (!p.teaser) {
          window.open(environment.innoLiveUrl, '_blank');
          this._router.navigate(['/']);
        }
      });
    forkJoin([this.configurationService.fromCache('InnoLiveAssets')])
      .pipe(rxfilter(() => !!this.authService.permissions.INNO_LIVE))
      .subscribe({
        next: (config: string[]) => {
          this.configuration = config;
          this.loading.isLoading = false;
          this.loading.isGlobalLoader = true;
        },
        error: () => {
          this.loading.isLoading = false;
          this.loading.isGlobalLoader = true;
        },
      });
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }

  getImageCount() {
    return parseInt(this.configuration[0], 10);
  }

  getAssets() {
    const json = this.configuration[0];
    if (!isJsonString(json)) {
      return [];
    }
    const assetsConfig = JSON.parse(json);
    return isNil(assetsConfig.assets) ? [] : filter(assetsConfig.assets, (a) => !!a.asset && a.asset.length > 0);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }

  redirectToMoreInfo() {
    window.open(environment.innoLiveMoreDetailsUrl, '_blank');
  }

  redirectToDemo() {
    window.open(environment.innoLiveDemoUrl, '_blank');
  }
}
